import React, { FC } from 'react';

import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import TableRowWithActions from '../../../../components/UI/TableRowWithActions';
import { Team } from '../../../../types';
import useTableStyles from '../AllTeamView/styles';
import { CardSection } from '../CardSection';
import { CardTitle } from '../CardTitle';
import useStyles from './styles';

interface LearnerTeamViewProps {
  teams?: Team[] | null;
}

const LearnerTeamView: FC<LearnerTeamViewProps> = ({ teams }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const tableClasses = useTableStyles();

  return (
    <Box className={classes.wrapper}>
      <CardTitle titleClass={classes.title} title={t('page.account.myTeam')} />
      <CardSection
        title={t('page.account.individualTeamDetails')}
        text={[t('page.account.individualTeamInfo')]}
      >
        <Box className={tableClasses.tableWrap}>
          <Box className={tableClasses.table}>
            {teams &&
              teams.map((item) => (
                <TableRowWithActions key={item?.id}>
                  <Box className={classes.teamNameCell}>
                    {t('page.account.teamName', { name: item?.name })}
                  </Box>
                  <Box className={classes.managersCell}>
                    {item?.managers?.map((manager) => (
                      <p key={manager?.id} className={classes.cellTextItem}>
                        {manager?.name}
                      </p>
                    ))}
                  </Box>
                </TableRowWithActions>
              ))}
          </Box>
        </Box>
      </CardSection>
    </Box>
  );
};

export default LearnerTeamView;
